import { MONTHS } from '@constants/calendar';

const currentYear = new Date().getFullYear();
export const YEARS = Array.from({ length: 5 }, (_, i) =>
	String(currentYear + i),
);

const DATE_OPTIONS_TUPLE = ['specificDate', 'monthYear'] as const;
export type DateOption = (typeof DATE_OPTIONS_TUPLE)[number];

export const DATE_OPTIONS: ReadonlySet<string> = new Set(DATE_OPTIONS_TUPLE);

export const isDateOption = (value: string): value is DateOption =>
	DATE_OPTIONS.has(value);

export interface WeddingDateData {
	dateOption: DateOption | '';
	specificDate: string;
	month: string;
	year: string;
}

export const isPastDate = (dateStr: string): boolean => {
	if (!dateStr) return false;
	const today = new Date();
	today.setHours(0, 0, 0, 0);
	const date = new Date(`${dateStr}T00:00:00`);
	if (Number.isNaN(date.getTime())) return false;
	return date < today;
};

export const isPastMonthYear = (month: string, year: string): boolean => {
	if (!month || !year) return false;
	const now = new Date();
	const thisMonth = now.getMonth();
	const thisYear = now.getFullYear();
	const monthIndex = MONTHS.indexOf(month);
	if (monthIndex === -1) return false;
	const y = Number(year);
	return y < thisYear || (y === thisYear && monthIndex < thisMonth);
};

export const WEDDING_DATE_EMPTY_ERROR = 'Enter a valid wedding date.';
export const WEDDING_DATE_PAST_ERROR = 'Enter a future date.';

export const getWeddingDateError = (
	weddingDate: WeddingDateData,
): string | undefined => {
	const { dateOption, specificDate, month, year } = weddingDate;
	if (!dateOption) return WEDDING_DATE_EMPTY_ERROR;
	if (dateOption === 'specificDate') {
		if (!specificDate) return WEDDING_DATE_EMPTY_ERROR;
		const parsed = new Date(`${specificDate}T00:00:00`);
		if (Number.isNaN(parsed.getTime())) return WEDDING_DATE_EMPTY_ERROR;
		if (isPastDate(specificDate)) return WEDDING_DATE_PAST_ERROR;
	}
	if (dateOption === 'monthYear') {
		if (!month || !year) return WEDDING_DATE_EMPTY_ERROR;
		if (isPastMonthYear(month, year)) return WEDDING_DATE_PAST_ERROR;
	}
	return undefined;
};
